import { SearchOption } from '@emi/shared/models';

export const SkuSearchOptions: SearchOption[] = [
    { value: 1, label: 'All' },
    { value: 2, label: 'Categories' },
    { value: 3, label: 'Suppliers' },
    { value: 4, label: 'Brands' },
    { value: 5, label: 'SKUs' },
    { value: 6, label: 'Attributes' },
    { value: 7, label: 'Retailers' },
];

export const SKU_SEARCH_SUGGESTION_TYPE: Record<string, string> = {
    'categories': 'Categories',
    'suppliers': 'Suppliers',
    'brands': 'Brands',
    'retailers': 'Retailers',
    'attributes': 'Attributes',
    'skus': 'SKUs'
}

export const ResultsPerPage = 15;
export const SuggestionsCount = 10;
export const DEBOUNCE_TIME = 1000;
export const SEARCH_TERM_FILTER = `^a-zA-Z0-9 ä ü ï ö ë ÿ !@&'-'`;
